import { render, staticRenderFns } from "./ClassesCubagem.vue?vue&type=template&id=55ef139c&scoped=true"
import script from "./ClassesCubagem.vue?vue&type=script&lang=js"
export * from "./ClassesCubagem.vue?vue&type=script&lang=js"
import style0 from "./ClassesCubagem.vue?vue&type=style&index=0&id=55ef139c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ef139c",
  null
  
)

export default component.exports